module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.showForgotDiv == false) ? _c('div', [_c('div', {
    staticClass: "my-login-page formcard"
  }, [_c('section', {
    staticClass: "h-100"
  }, [_c('div', {
    staticClass: "row align-items-center main-login-page",
    staticStyle: {
      "height": "100vh",
      "background-color": "#fff"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 login-card"
  }, [_c('div', {
    staticClass: "brand"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-body auth-form-light text-left",
    staticStyle: {
      "padding": "4rem"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "#5e5873",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                    Welcome to Pridel! 👋\n                  ")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "line-height": "1.5rem",
      "color": "#6e6b7b"
    }
  }, [_vm._v("\n                    Please sign-in to your account and start the adventure\n                  ")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "/"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "color": "#5e5873",
      "font-size": "0.857rem"
    },
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    staticClass: "input-box",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Username"
    },
    model: {
      value: (_vm.payload.email),
      callback: function($$v) {
        _vm.$set(_vm.payload, "email", $$v)
      },
      expression: "payload.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "color": "#5e5873",
      "font-size": "0.857rem"
    },
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    staticClass: "input-box",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "type": "password",
      "required": "",
      "placeholder": "Enter Password"
    },
    model: {
      value: (_vm.payload.password),
      callback: function($$v) {
        _vm.$set(_vm.payload, "password", $$v)
      },
      expression: "payload.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "pull-right showMoreData",
    staticStyle: {
      "font-size": "0.857rem",
      "font-weight": "400",
      "color": "#525584",
      "margin-top": "-10px !important"
    },
    attrs: {
      "for": "checkbox1"
    },
    on: {
      "click": _vm.openForgotDiv
    }
  }, [_vm._v("Forgot Password?")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mt-4"
  }, [_c('b-button', {
    staticClass: "btn-primary btn-block mt-3",
    staticStyle: {
      "text-transform": "none",
      "padding": "0.375rem 0.75rem"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.loginNew
    }
  }, [_vm._v("Sign in")])], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-top20 text-center"
  })])])])])])])])]) : _c('div', {
    staticClass: "container2"
  }, [(_vm.showResetModal == false) ? _c('div', [_c('div', {
    staticClass: "my-login-page formcard"
  }, [_c('section', {
    staticClass: "h-100"
  }, [_c('div', {
    staticClass: "row align-items-center main-login-page",
    staticStyle: {
      "height": "100vh",
      "background-color": "#fff"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 login-card"
  }, [_c('div', {
    staticClass: "brand"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-body auth-form-light text-left",
    staticStyle: {
      "padding": "4rem"
    }
  }, [_c('h5', {
    staticStyle: {
      "color": "#5e5873",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                      Forgot Password? 🔒\n                    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.9rem",
      "line-height": "1.5rem",
      "color": "#6e6b7b",
      "font-weight": "400",
      "margin-bottom": "calc(1rem - 10px)"
    }
  }, [_vm._v("\n                      Enter your email and we'll send you instructions to reset your\n                      password\n                    ")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "/"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "color": "#5e5873",
      "font-size": "0.857rem"
    },
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    ref: "email",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "type": "text",
      "required": true,
      "placeholder": "Enter Username"
    },
    model: {
      value: (_vm.forgotModel.emailForgot),
      callback: function($$v) {
        _vm.$set(_vm.forgotModel, "emailForgot", $$v)
      },
      expression: "forgotModel.emailForgot"
    }
  }), _vm._v(" "), (!_vm.forgotModel.emailForgot) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.emailForgotError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group mt-4"
  }, [_c('b-button', {
    staticClass: "pull-left btn-primary btn-block mt-3",
    staticStyle: {
      "text-transform": "none",
      "padding": "0.375rem 0.75rem"
    },
    attrs: {
      "variant": "primary",
      "required": ""
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v("Recover Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group mt-4"
  }, [_c('b-button', {
    staticClass: "pull-right btn-block",
    staticStyle: {
      "border": "1px solid #52548314",
      "text-transform": "none"
    },
    attrs: {
      "variant": "light"
    },
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v("Back To Login")])], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-top20 text-center"
  })])])])])])])])]) : _c('div', [_c('div', {
    staticClass: "my-login-page formcard"
  }, [_c('section', {
    staticClass: "h-100"
  }, [_c('div', {
    staticClass: "container h-100"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-7 col-lg-5"
  }, [_c('div', {
    staticClass: "brand"
  }), _vm._v(" "), _c('div', {
    staticClass: "card fat formCard",
    staticStyle: {
      "width": "400px",
      "box-shadow": "0 4px 8px 0 rgba(0, 0, 0, 0.2),"
    }
  }, [_c('div', {
    staticClass: "card-body auth-form-light text-left p-5"
  }, [_c('h5', {
    staticClass: "font-weight-light"
  }, [_vm._v("Please Enter New password...!")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-light text-muted"
  }, [_vm._v("\n                        Note : OTP has been Sent to Registered Email Address\n                      ")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "/"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "for": "email"
    }
  }, [_vm._v("New Password")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    ref: "email",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "type": "text",
      "required": true,
      "placeholder": "Enter Password"
    },
    on: {
      "keyup": _vm.samePassword
    },
    model: {
      value: (_vm.PasswordModal.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.PasswordModal, "newPassword", $$v)
      },
      expression: "PasswordModal.newPassword"
    }
  })], 1), _vm._v(" "), (_vm.PasswordModal.passNotMatchErr != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.passNotMatchErr))]) : _vm._e(), _vm._v(" "), (_vm.PasswordModal.passLessThanError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.passLessThanError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    ref: "email",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "type": "text",
      "required": true,
      "placeholder": "Re-Enter Password"
    },
    on: {
      "keyup": _vm.samePassword
    },
    model: {
      value: (_vm.PasswordModal.confPassword),
      callback: function($$v) {
        _vm.$set(_vm.PasswordModal, "confPassword", $$v)
      },
      expression: "PasswordModal.confPassword"
    }
  })], 1), _vm._v(" "), (_vm.PasswordModal.passNotMatchErr != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.passNotMatchErr))]) : _vm._e(), _vm._v(" "), (_vm.PasswordModal.passLessThanError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.passLessThanError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "for": "email"
    }
  }, [_vm._v("OTP (Sent on registered email)")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    ref: "email",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "type": "text",
      "required": true,
      "placeholder": "Enter OTP"
    },
    on: {
      "keyup": _vm.samePassword
    },
    model: {
      value: (_vm.PasswordModal.emailOTP),
      callback: function($$v) {
        _vm.$set(_vm.PasswordModal, "emailOTP", $$v)
      },
      expression: "PasswordModal.emailOTP"
    }
  })], 1), _vm._v(" "), (_vm.PasswordModal.emailOTPError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.emailOTPError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group mt-4"
  }, [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v("Reset Password\n                          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "light"
    },
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v("Back To Login")])], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-top20 text-center"
  })])])])])])])])])])])]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "confirm_dailog",
    attrs: {
      "md-title": _vm.error.title,
      "md-content-html": _vm.error.message,
      "md-ok-text": _vm.error.okText,
      "md-cancel-text": _vm.error.cancelText
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop1",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopInvalidEmail",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), (_vm.showtoast) ? _c('div', {
    staticClass: "toast-nit"
  }, [_c('p', [_vm._v(_vm._s(_vm.toastmsg))])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "2rem",
      "top": "1.5rem",
      "z-index": "999"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/assets/loginlogoblue.png",
      "width": "50%",
      "height": "50%",
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8 bg-img",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "height": "100vh !important"
    },
    attrs: {
      "src": "/assets/dashboard-bg-img.png",
      "width": "100%",
      "alt": "image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8 bg-img",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "height": "100vh !important"
    },
    attrs: {
      "src": "/assets/forgotpage-img.PNG",
      "width": "100%",
      "alt": "image"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-311dd073","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/login/login.vue
// module id = 2500
// module chunks = 0